(function () {
  if (window.__belovedQuantityBreaksCartFixLoaded) return;
  window.__belovedQuantityBreaksCartFixLoaded = true;

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function getFormId(form) {
    return form.getAttribute('id') || '';
  }

  function getQuantityBreaks(form) {
    var sectionIdInput = form.querySelector('input[name="section-id"]');
    var sectionId = sectionIdInput ? sectionIdInput.value : '';
    if (sectionId) {
      var bySection = document.querySelector('quantity-breaks[data-section="' + cssEscape(sectionId) + '"]');
      if (bySection) return bySection;
    }

    var formId = getFormId(form);
    if (formId) {
      var quantityInput = document.querySelector('input[name="quantity"][form="' + cssEscape(formId) + '"]');
      if (quantityInput) return quantityInput.closest('quantity-breaks');
    }

    var scopedRoot = form.closest('product-info, .product, .shopify-section, section, main');
    if (scopedRoot) {
      var scopedQuantityBreaks = scopedRoot.querySelector('quantity-breaks');
      if (scopedQuantityBreaks) return scopedQuantityBreaks;
    }

    return document.querySelector('quantity-breaks');
  }

  function getSelectedQuantityInput(quantityBreaks, form) {
    var formId = getFormId(form);
    var selector = 'input[name="quantity"]:checked';
    if (formId) selector = 'input[name="quantity"][form="' + cssEscape(formId) + '"]:checked';
    return quantityBreaks.querySelector(selector) || quantityBreaks.querySelector('input[name="quantity"]:checked');
  }

  function getActiveSelectorItems(quantityBreaks, quantityInput) {
    if (!quantityInput || !quantityInput.id) return [];
    var label = quantityBreaks.querySelector('label[for="' + cssEscape(quantityInput.id) + '"]');
    if (!label) return [];
    return Array.from(label.querySelectorAll('.quantity-break__selector-item[data-selected-id]'));
  }

  function getProperties(formData) {
    var properties = {};
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.*)\]$/);
      if (match) properties[match[1]] = value;
    });
    return properties;
  }

  function propertiesKey(properties) {
    return Object.keys(properties)
      .sort()
      .map(function (key) {
        return key + ':' + properties[key];
      })
      .join('|');
  }

  function hasInvalidVariantIds(selectorItems) {
    return selectorItems.some(function (selectorItem) {
      return !Number(selectorItem.dataset.selectedId);
    });
  }

  function buildItems(selectorItems, formData) {
    var properties = getProperties(formData);
    var sellingPlan = formData.get('selling_plan');
    var grouped = new Map();

    selectorItems.forEach(function (selectorItem) {
      var variantId = Number(selectorItem.dataset.selectedId);
      if (!variantId) return;

      var key = [variantId, sellingPlan || '', propertiesKey(properties)].join('::');
      if (!grouped.has(key)) {
        var item = {
          id: variantId,
          quantity: 0,
        };
        if (sellingPlan) item.selling_plan = sellingPlan;
        if (Object.keys(properties).length) item.properties = properties;
        grouped.set(key, item);
      }
      grouped.get(key).quantity += 1;
    });

    return Array.from(grouped.values());
  }

  function setButtonLoading(button, loading) {
    if (!button) return;
    button.classList.toggle('loading', loading);
    button.toggleAttribute('aria-disabled', loading);
    if (loading) {
      button.setAttribute('disabled', 'disabled');
    } else {
      button.removeAttribute('disabled');
    }
  }

  function rootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  async function refreshNativeCart(cartState) {
    var sections = (cartState && cartState.sections) || {};
    var drawer = document.querySelector('cart-drawer');
    var drawerHtml = sections['cart-drawer'];
    var bubbleHtml = sections['cart-icon-bubble'];

    if (drawer && drawerHtml) {
      var drawerDocument = new DOMParser().parseFromString(drawerHtml, 'text/html');
      var nextDrawer = drawerDocument.querySelector('cart-drawer');
      if (nextDrawer) {
        drawer.replaceWith(nextDrawer);
        drawer = nextDrawer;
      }
    }

    if (bubbleHtml) {
      var bubbleDocument = new DOMParser().parseFromString(bubbleHtml, 'text/html');
      var currentBubble = document.getElementById('cart-icon-bubble');
      var nextBubble = bubbleDocument.getElementById('cart-icon-bubble');
      if (currentBubble && nextBubble) currentBubble.replaceWith(nextBubble);
    }

    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }

    window.location.href = rootPath() + 'cart';
    return false;
  }

  async function handleQuantityBreakForm(form, event) {
    if (!(form instanceof HTMLFormElement)) return false;
    if (!/\/cart\/add/i.test(form.action || '')) return;
    if (form.dataset.quantityBreaksCartFixSubmitting === 'true') return true;

    var quantityBreaks = getQuantityBreaks(form);
    if (!quantityBreaks) return;

    var quantityInput = getSelectedQuantityInput(quantityBreaks, form);
    var selectedQuantity = Number(quantityInput && quantityInput.value);
    if (!selectedQuantity || selectedQuantity < 2) return;

    var selectorItems = getActiveSelectorItems(quantityBreaks, quantityInput);
    if (selectorItems.length !== selectedQuantity) {
      event.preventDefault();
      event.stopImmediatePropagation();
      console.error('Quantity-break add blocked: selector count does not match selected quantity.', {
        selectedQuantity: selectedQuantity,
        selectorItemsLength: selectorItems.length,
      });
      return false;
    }

    if (hasInvalidVariantIds(selectorItems)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      console.error('Quantity-break add blocked: one or more selected variants are invalid.');
      return false;
    }

    var formData = new FormData(form);
    var items = buildItems(selectorItems, formData);
    if (items.length === 0) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    form.dataset.quantityBreaksCartFixSubmitting = 'true';

    var submitButton = form.querySelector('[type="submit"], button[name="add"]');
    setButtonLoading(submitButton, true);

    try {
      var response = await fetch(rootPath() + 'cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: items,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) {
        var message = await response.text();
        throw new Error(message || 'Unable to add selected variants to cart.');
      }

      var cartState = await response.json();
      window.dispatchEvent(new CustomEvent('beloved:quantity-breaks:add', { detail: { items: items } }));
      await refreshNativeCart(cartState);
    } catch (error) {
      console.error('Quantity-break add-to-cart failed. No fallback submit was attempted to avoid adding the wrong variants.', error);
      window.dispatchEvent(new CustomEvent('beloved:quantity-breaks:error', { detail: { error: error, items: items } }));
    } finally {
      form.dataset.quantityBreaksCartFixSubmitting = 'false';
      setButtonLoading(submitButton, false);
    }

    return true;
  }

  function handleQuantityBreakSubmit(event) {
    handleQuantityBreakForm(event.target, event);
  }

  function handleQuantityBreakClick(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var button = target.closest('button[name="add"], button[type="submit"], input[type="submit"]');
    if (!button || !button.form) return;
    handleQuantityBreakForm(button.form, event);
  }

  document.addEventListener('click', handleQuantityBreakClick, true);
  document.addEventListener('submit', handleQuantityBreakSubmit, true);
})();

